import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GENERIC_AUTH_SERVICE_TOKEN, GenericAuthService } from '@nk/auth-lib';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [CommonModule, RouterLink, TranslateModule],
  templateUrl: './sso-trigger.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SsoTriggerComponent implements OnInit {
  constructor(
    @Inject(GENERIC_AUTH_SERVICE_TOKEN) private _authService: GenericAuthService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
  ) {}

  public ngOnInit(): void {
    this._activatedRoute.params.subscribe((params) => {
      const connection = params['connection'] as string;
      if (connection && connection.length > 0) {
        this._authService.authorize(connection);
      } else {
        console.error('Missing parameter for connection, redirecting to 404');
        this._router.navigate(['/404']);
      }
    });
  }
}
